import { Dialog, DialogActions, DialogContent } from "@mui/material";

function ImagineDialog({
    open,
    onClose,
    dialogContent, // JSX or component for the content
    dialogActions, // JSX or component for the actions
  }) {
    return ( 

        <>
        <Dialog open={open} onClose={onClose}>
        <DialogContent>
         {dialogContent}
        </DialogContent>
        <DialogActions>
          {dialogActions}
        </DialogActions>
      </Dialog>
        </>
     );
}

export default ImagineDialog;